import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo, useContext } from 'react';
import _Button from '../Button/index.js';
import { ModalContext } from './ModalContext.js';

var _excluded = ["footerPrimaryRenderButton", "footerSecondaryRenderButton", "footerContentPosition"];
var _templateObject;
var StyledModalFooter = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-top: 1px solid\n    ", ";\n  display: flex;\n  justify-content: ", ";\n  padding: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette[theme.modal.headerDividerColor];
}, function (_ref2) {
  var footerContentPosition = _ref2.footerContentPosition;
  return footerContentPosition;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.modal.footerPadding;
});
var ModalFooter = function ModalFooter(_ref4) {
  var FooterPrimaryRenderButton = _ref4.footerPrimaryRenderButton,
    FooterSecondaryRenderButton = _ref4.footerSecondaryRenderButton,
    footerContentPosition = _ref4.footerContentPosition,
    rest = _objectWithoutProperties(_ref4, _excluded);
  var _useContext = useContext(ModalContext),
    footerPrimaryButtonText = _useContext.footerPrimaryButtonText,
    hideModal = _useContext.hideModal,
    theme = _useContext.theme;
  return /*#__PURE__*/React.createElement(StyledModalFooter, {
    theme: theme,
    className: 'modal_footer',
    footerContentPosition: footerContentPosition
  }, !!FooterPrimaryRenderButton ? /*#__PURE__*/React.createElement(FooterPrimaryRenderButton, {
    hideModal: hideModal,
    theme: theme
  }) : /*#__PURE__*/React.createElement(_Button, _extends({
    role: 'button',
    buttonType: "primary",
    onClick: hideModal,
    theme: theme
  }, rest), footerPrimaryButtonText), !!FooterSecondaryRenderButton && /*#__PURE__*/React.createElement(FooterSecondaryRenderButton, {
    hideModal: hideModal,
    theme: theme
  }));
};
var ModalFooter$1 = /*#__PURE__*/memo(ModalFooter);

export default ModalFooter$1;
export { ModalFooter };
